import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { Form, Button, Spinner } from "react-bootstrap";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { RiCloseFill } from "react-icons/ri";
import Request from "../../Request";
import { STORAGE_FILES_URL } from "../../variables";


const ModalSendCertificate = props => {
    const { showModal, setShowModal, candidato, processo_id, onFinish } = props;
    const [file, setFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [existingCertificate, setExistingCertificate] = useState(null);
    const [loadingCertificate, setLoadingCertificate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [msgErro, setMessageErro] = useState('');
    const [msgSuccess, setMessageSuccess] = useState('');

    useEffect(() => {
        if (showModal && candidato?.id && processo_id) {
            fetchExistingCertificate();
        }
    }, [showModal, candidato, processo_id]);

    const fetchExistingCertificate = async () => {
        setLoadingCertificate(true);

        console.log("processo_id",processo_id, "candidato.id", candidato.id);

        const response = await Request.Get(`certificados/${processo_id}/${candidato.id}`);
        setLoadingCertificate(false);

        if (response && response.result === true && response.data?.certificado) {
            setExistingCertificate(response.data.certificado);
        } else {
            setExistingCertificate(null);
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
        const fileType = selectedFile.type;

        if (!allowedTypes.includes(fileType)) {
            setMessageErro("Formato de arquivo inválido. Apenas PDF, JPEG, JPG e PNG são permitidos.");
            setFile(null);
            setFilePreview(null);
            setFileType(null);
            e.target.value = '';
            return;
        }

        const previewUrl = URL.createObjectURL(selectedFile);
        setFile(selectedFile);
        setFilePreview(previewUrl);
        setFileType(fileType);
        setMessageErro('');
    };

    const handleSend = async () => {
        if (!file) {
            setMessageErro("Por favor, selecione um arquivo.");
            return;
        }

        setLoading(true);
        setMessageErro('');
        setMessageSuccess('');

        const formData = new FormData();
        formData.append('candidato_id', candidato.id);
        formData.append('file', file);

        const response = await Request.Post(`certificados/${processo_id}`, formData);

        setLoading(false);

        if (response && response.result === true) {
             const message = existingCertificate ? "Certificado atualizado com sucesso!" : "Certificado enviado com sucesso!";
             setMessageSuccess(message);
             setTimeout(() => {
                 setShowModal(false);
                 setFile(null);
                 setFilePreview(null);
                 setFileType(null);
                 setMessageSuccess('');
                 if(onFinish) onFinish();
             }, 2000);
        } else {
            setMessageErro(response?.message || "Erro ao enviar certificado.");
        }
    };

    return (
        <Modal
            show={showModal}
            onHide={() => {
                setShowModal(false);
                setFile(null);
                setFilePreview(null);
                setFileType(null);
                setMessageErro('');
                setMessageSuccess('');
            }}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Certificado/Declaração de {candidato?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {msgErro && <div className="alert alert-danger">{msgErro}</div>}
                {msgSuccess && <div className="alert alert-success">{msgSuccess}</div>}

                {loadingCertificate && (
                    <div className="text-center mb-3">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <span>Carregando certificado...</span>
                    </div>
                )}

                {!loadingCertificate && existingCertificate && (
                    <div className="mb-3">
                        <div className="alert alert-info overflow-auto">
                            <strong>Certificado/Declaração Atual:</strong> {existingCertificate.name}
                            <br />
                            <small>Gerado em: {new Date(existingCertificate.created_at).toLocaleString('pt-BR')}</small>
                        </div>
                        <div className="border rounded p-3 mb-3" style={{ maxHeight: '400px', overflow: 'auto', backgroundColor: '#f8f9fa' }}>
                            {existingCertificate.mime === 'application/pdf' ? (
                                <embed 
                                    src={STORAGE_FILES_URL + existingCertificate.path}
                                    type="application/pdf" 
                                    width="100%" 
                                    height="500px"
                                    style={{ border: 'none' }}
                                />
                            ) : (
                                <img 
                                    src={STORAGE_FILES_URL + existingCertificate.path}
                                    alt="Certificado atual" 
                                    style={{ width: '100%', height: 'auto', maxHeight: '500px', objectFit: 'contain' }}
                                />
                            )}
                        </div>
                    </div>
                )}


               

                
            </Modal.Body>
        </Modal>
    );
};

export default ModalSendCertificate;
